import templateUrl from './process-direct-deposit.component.html';
import { DirectDepositVM } from './employment-processing-models';
import { EventEmitter } from '../../common/components/event-emitter';

export const ProcessDirectDepositComponent = {
    templateUrl,
    controller: class ProcessDirectDepositComponent {
        fileName: string;
        directDeposit: DirectDepositVM[];
        handleCancel: EventEmitter<any>;
        handleFinish: EventEmitter<any>;
        pageNumber = 1;
        pageSize = 10;

        $onInit() {
            console.log(this.directDeposit);
        }

        selectionCount() {
            return this.directDeposit.reduce(function (count, number) {
                return count + (number.IsSelected ? 1 : 0);
            }, 0);
        }
    },
    controllerAs: "vm",
    bindings: {
        fileName: "<",
        directDeposit: "<",
        handleCancel: "&",
        handleFinish: "&"
    }
};
